// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"organism1-m__wrapper__bMYBG"};